import React, {useMemo} from 'react'

import cn from 'classnames/bind'
import dynamic from 'next/dynamic'

import paystubDefaults from 'components/blocks/documents/DocumentPaystub/templates/config/templates.defaultValues'
import s from 'components/blocks/forms/FormPayStubNew/PayStubChooseTemplateNew/PayStubChooseTemplateNew.module.scss'
import SpinnerDots from 'components/elements/SpinnerDots'
import {proxyDefaultWrapper} from 'src/utils'
import {usePayStubStore} from 'src/utils/contexts/RootStore.context'

const cx = cn.bind(s)

const Loading = () => (
	<div className={cx('loading')}>
		<SpinnerDots size="m" position="center" />
	</div>
)

const PaystubTemplate1 = dynamic(
	() => import('components/blocks/documents/DocumentPaystub/templates/PaystubTemplate1'),
	{
		loading: Loading,
		ssr: false,
	},
)

const PaystubTemplate2 = dynamic(
	() => import('components/blocks/documents/DocumentPaystub/templates/PaystubTemplate2'),
	{
		loading: Loading,
		ssr: false,
	},
)
const PaystubTemplate3 = dynamic(
	() => import('components/blocks/documents/DocumentPaystub/templates/PaystubTemplate3'),
	{
		loading: Loading,
		ssr: false,
	},
)
const PaystubTemplate4 = dynamic(
	() => import('components/blocks/documents/DocumentPaystub/templates/PaystubTemplate4'),
	{
		loading: Loading,
		ssr: false,
	},
)
const PaystubTemplate5 = dynamic(
	() => import('components/blocks/documents/DocumentPaystub/templates/PaystubTemplate5'),
	{
		loading: Loading,
		ssr: false,
	},
)
const PaystubTemplate6 = dynamic(
	() => import('components/blocks/documents/DocumentPaystub/templates/PaystubTemplate6'),
	{
		loading: Loading,
		ssr: false,
	},
)

interface IPayStubChooseTemplateProps {
	activeTemplate: IPayStubTemplates | undefined
}

const PaystubTemplatePreview = ({activeTemplate}: IPayStubChooseTemplateProps) => {
	const payStubStore = usePayStubStore()
	const payStubStoreWithDefaults = proxyDefaultWrapper(payStubStore, paystubDefaults)
	const {isCalculationLoading, isCalculationValid} = payStubStore

	const PaystubTemplate = useMemo(() => {
		switch (activeTemplate?.id) {
			case 2:
				return PaystubTemplate2
			case 3:
				return PaystubTemplate3
			case 4:
				return PaystubTemplate4
			case 5:
				return PaystubTemplate5
			case 6:
				return PaystubTemplate6
			default:
				return PaystubTemplate1
		}
	}, [activeTemplate?.id])

	if (isCalculationLoading) {
		return (
			<div className={cx('spinner')} data-testid="calculationLoading">
				<div className={cx('spinner__wrapper')}>
					<SpinnerDots className={cx('spinner__inner')} />
				</div>
			</div>
		)
	}

	return (
		<PaystubTemplate
			className={cx('preview--new', `pst${activeTemplate?.id}--new`, {
				blur: isCalculationLoading || !isCalculationValid,
			})}
			data={payStubStoreWithDefaults}
			hasFrame
			activeItem={payStubStore.activeDataTemplate}
			theme={activeTemplate?.theme}
		/>
	)
}

export default PaystubTemplatePreview
